<template>
  <section>
    <div class="structured-top">
      <h1 v-mark-word>{{ $t('prices.title') }}</h1>
      <p>{{ $t('prices.description', { vatPercent }) }}</p>
    </div>
    <div class="structured-content">
      <template v-for="groupCode in groupCodes" :key="`${groupCode}Title`">
        <h2 class="mt-0">{{ $t(`prices.group.${groupCode}`) }}</h2>
        <table class="table structure-table single-line">
          <thead>
            <tr>
              <th>{{ $t('prices.labels.product') }}</th>
              <th class="text-end">{{ $t('prices.labels.price') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in groupedProducts[groupCode]" :key="product.id">
              <template v-if="product.price !== null">
                <td class="d-table-cell">
                  <router-link :to="{ name: `report-${this.$i18n.locale}`, params: { ...product, lang: this.$i18n.locale } }">
                    {{ product.descriptiveTitle || product.title }}
                  </router-link>
                  <span class="d-block subrow" v-for="(item, index) in getSubItemsOf(product)" :key="index">
                    {{ titleFor(item, product) }}
                  </span>
                </td>
                <td class="d-table-cell text-end fw-bold">
                  <template v-if="getSubItemsOf(product)">
                    <span class="d-block">&nbsp;</span>
                    <span class="d-block subrow" v-for="(item, index) in getSubItemsOf(product)" :key="index">
                      {{ $price(item.price) }}
                    </span>
                  </template>
                  <template v-else>{{ $price(product.price) }}</template>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('product', ['groupedProducts', 'groupCodes', 'vatPercent']),
  },
  methods: {
    getSubItemsOf(product) {
      return product.subscriptions || product.services;
    },
    titleFor(item, product) {
      return item.code ? product.serviceDetails[item.code].title : this.$subscriptionTitle(item);
    },
  },
  metaInfo() {
    return {
      title: this.$t('prices.meta.title'),
      meta: [
        { vmid: 'keywords', name: 'keywords', content: this.$t('prices.meta.keywords') },
        { vmid: 'description', name: 'description', content: this.$t('prices.meta.description') },
      ],
    };
  },
};
</script>
